<script lang="ts" setup>
const {
  toggleNavigation,
} = useNavigation()
</script>

<template>
  <button
    type="button"
    class="navigation-toggle"
    aria-haspopup="true"
    aria-expanded="false"
    aria-controls="navigation"
    @click="toggleNavigation"
  >
    <NuxtIcon name="icon:menu" />
    <span class="navigation-toggle__label">{{ $t('Menu') }}</span>
  </button>
</template>

<style>
@import url("~layers/components/Navigation/Toggle.css");
</style>
